var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H1.25C1.25 9.41421 1.58579 9.75 2 9.75V9ZM2 15V14.25C1.58579 14.25 1.25 14.5858 1.25 15H2ZM22 15H22.75C22.75 14.5858 22.4142 14.25 22 14.25V15ZM22 9V9.75C22.4142 9.75 22.75 9.41421 22.75 9H22ZM21 5.75C21.1381 5.75 21.25 5.86193 21.25 6H22.75C22.75 5.0335 21.9665 4.25 21 4.25V5.75ZM3 5.75H21V4.25H3V5.75ZM2.75 6C2.75 5.86193 2.86193 5.75 3 5.75V4.25C2.0335 4.25 1.25 5.0335 1.25 6H2.75ZM2.75 9V6H1.25V9H2.75ZM5.75 12C5.75 9.92893 4.07107 8.25 2 8.25V9.75C3.24264 9.75 4.25 10.7574 4.25 12H5.75ZM2 15.75C4.07107 15.75 5.75 14.0711 5.75 12H4.25C4.25 13.2426 3.24264 14.25 2 14.25V15.75ZM2.75 18V15H1.25V18H2.75ZM3 18.25C2.86193 18.25 2.75 18.1381 2.75 18H1.25C1.25 18.9665 2.0335 19.75 3 19.75V18.25ZM21 18.25H3V19.75H21V18.25ZM21.25 18C21.25 18.1381 21.1381 18.25 21 18.25V19.75C21.9665 19.75 22.75 18.9665 22.75 18H21.25ZM21.25 15V18H22.75V15H21.25ZM22 14.25C20.7574 14.25 19.75 13.2426 19.75 12H18.25C18.25 14.0711 19.9289 15.75 22 15.75V14.25ZM19.75 12C19.75 10.7574 20.7574 9.75 22 9.75V8.25C19.9289 8.25 18.25 9.92893 18.25 12H19.75ZM21.25 6V9H22.75V6H21.25Z",
    fill: "#257FFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L13.1756 10.382L15.8042 10.7639L13.9021 12.618L14.3511 15.2361L12 14L9.64886 15.2361L10.0979 12.618L8.19577 10.7639L10.8244 10.382L12 8Z",
    stroke: "#257FFC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.6f37cd4c.svg";
export { ForwardRef as ReactComponent };